export const CREATE_VEHICLE_TYPE = 'CREATE_VEHICLE_TYPE';
export const EDIT_VEHICLE_TYPE = 'EDIT_VEHICLE_TYPE';
export const SHOW_VEHICLE_TYPE = 'SHOW_VEHICLE_TYPE';
export const VEHICLE_TYPE_SUCCESS = 'VEHICLE_TYPE_SUCCESS';
export const VEHICLE_TYPE_ERROR = 'VEHICLE_TYPE_ERROR';